/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import SimpleInput from '/client/src/components/forms/simpleInput';
import _ from 'lodash';
import moment from 'moment';
import { validateDonationItem } from '../../validator/donations';
import { currency } from '/client/src/constants/';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';

type PropsType = {
  value?: {
    isNew?: boolean,
    id?: string | number,
    description?: string,
    name?: string,
    goal: number, // Donation Goal
    prefilled_amount: number, // Default donation amount
    is_active: boolean,
    placement_index: number | string,
    sale_begin_time_utc: string | number,
    sale_end_time_utc: string | number
  },
  data: {
    index: number | string,
    handleControlEventDonations: (data: Array) => void,
    tickets: [],
    donations: []
  },
  id: string | number,
  index: number | string
};

const DItem = (props: PropsType): React.Element => {
  const context = React.useContext(DefaultContainerContext);

  const _id = props.value.id;
  const tickets = _.get(props, 'data.tickets', []);

  let singleLevelObjIndex = 0;

  const singleLevelObj = _.find(props.data.donations, (l: {}, li: number): {} => {
    if (_.toString(l.id) === _.toString(_id)) {
      singleLevelObjIndex = li;

      return l;
    }
  });

  const [name, setName] = React.useState(singleLevelObj ? singleLevelObj.name : '');
  const [description, setDescription] = React.useState(singleLevelObj ? singleLevelObj.description : '');
  const [goal, setGoal] = React.useState(singleLevelObj ? singleLevelObj.goal : 0);
  const [prefilled_amount, setPrefilled_amount] = React.useState(singleLevelObj ? singleLevelObj.prefilled_amount : 2);
  const [isShowLimitLabel, toggleShowLimitLabel] = React.useState(false);
  const descLimit = 512;
  const [isShowDescLimitWarning, toggleShowDescLimitWarning] = React.useState(_.size(description) > descLimit);

  const setDonations = () => {
    const _donations = _.clone(props.data.donations);

    _donations[singleLevelObjIndex] = {
      ..._donations[singleLevelObjIndex],
      description,
      name,
      goal,
      prefilled_amount,
      isNew: props.value.isNew,
      sale_begin_time_utc: _.get(tickets, '[0].sale_begin_time_utc', moment().utc().format()),
      sale_end_time_utc: _.get(tickets, '[0].sale_end_time_utc', moment().utc().format())
    };

    props.data.handleControlEventDonations(_donations);
  };

  return (
    <div className={'DonationItem'} data-id={_id} data-testid={`DonationItem-${props.data.index}`}>
      <div className="form-group">
        <div className="row">
          <div className="col-sm-6">
            <SimpleInput
              dataTestid={'DonationItem_name'}
              name={`name-DItem-${props.data.index}`}
              id={`name-DItem-${props.data.index}`}
              label='Donation Name'
              onChange={(e: any): void => setName(e.target.value)}
              value={name}
              onBlur={setDonations}
              validator={{}}
              maxLength={128}
              limit={128}
              isShowLimit
              limitCb={() => {}}
            />
          </div>

          <div className="col-sm-6">
            <div className="form-group SimpleInput" />
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6">
            <div
              className="form-group SimpleInput"
            >
              <label htmlFor={`description-DItem-${props.data.index}`}>
                Donation Descriptions
              </label>
              <textarea
                style={{
                  resize: 'vertical'
                }}
                className='form-control'
                name={`description-DItem-${props.data.index}`}
                id={`description-DItem-${props.data.index}`}
                rows="1"
                onChange={(e: any) => {
                  setDescription(e.target.value);
                  toggleShowDescLimitWarning(_.size(e.target.value) > descLimit);
                }}
                value={description}
                onFocus={() => {
                  toggleShowLimitLabel(true);
                }}
                onBlur={() => {
                  toggleShowLimitLabel(false);
                  setDonations();
                }}
                data-testid={'DonationItem_description'}
              />
              <div
                className={'vMsg'}
                style={{
                  display: isShowDescLimitWarning ? 'block' : 'none'
                }}
              >Please enter no more than {descLimit} characters.</div>

              {isShowLimitLabel &&
                <span
                  className='SimpleInput__limitPlaceholder SimpleInput__limitPlaceholder-addons'
                  style={{
                    top: '25px'
                  }}
                >
                  {_.size(description)}/{descLimit}
                </span>
              }
            </div>
          </div>

          <div className="col-sm-6">
            <div className="form-group SimpleInput" />
          </div>
        </div>

        <div className="row">
          <div className="hidden-sm hidden-lg hidden-md" style={{ height: '10px' }} />
          <div className="col-sm-6">
            <SimpleInput
              type='number'
              withAddon={currency[context.profileCurrent.currency]}
              addonPosition='start'
              name='goal'
              id={`goal-DItem-${props.data.index}`}
              label='Donation Goal'
              value={_.toString(goal / 100)}
              onChange={(e: any) => setGoal(e.target.value * 100)}
              onBlur={setDonations}
              dataTestid={'DonationItem_goal'}
            />
          </div>
          <div className="col-sm-6">
            <SimpleInput
              type='number'
              withAddon={currency[context.profileCurrent.currency]}
              addonPosition='start'
              name='prefilled_amount'
              id={`prefilled_amount-DItem-${_id}`}
              label='Default donation amount'
              value={_.toString(prefilled_amount / 100)}
              validator={{
                text: `Default donation amount cannot be lower than 2${currency[context.profileCurrent.currency]}`
              }}
              forceShowValidator={prefilled_amount < 200}
              onChange={(e: any) => {
                validateDonationItem({ ...props.value, prefilled_amount: e.target.value * 100 });
                setPrefilled_amount(e.target.value * 100);
              }}
              onBlur={setDonations}
              dataTestid={'DonationItem_amount'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DItem;
